<template>
  <div class="row" style="max-width: 100%">
    <div class="col-xl-12">
      <container-headline class="col-xl-12" :headline="'Dashboard'" :col="3">
      </container-headline>
      <div class="row col-xl-12">
        <div class="col-xl-12 block belegliste br-t-l-0">
          <div>
            <b-table
              ref="selectableTable"
              tbody-tr-class="item"
              :items="list"
              :fields="listFields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :busy="isBusy"
              show-empty
              sort-icon-left
              fixed
              selectable
              select-mode="multi"
              @row-clicked="details"
            >
              <template #table-busy>
                <div class="text-center text-primary my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>

              <template #empty>
                <div v-if="ladeFehler" class="text-center text-danger my-2">
                  <strong>Fehler beim Laden</strong>
                </div>
                <div v-if="!ladeFehler" class="text-center text-primary my-2">
                  <strong>Keine Daten vorhanden</strong>
                </div>
              </template>
              <template slot="row-details">
                <b-table
                  ref="table"
                  tbody-tr-class="item"
                  :items="allOpenRows"
                  :fields="allOpenRowsFields"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :busy="isBusy"
                  show-empty
                  sort-icon-left
                  fixed
                  select-mode="range"
                  class="detailTable"
                ></b-table>
              </template>
            </b-table>
            <infinite-loading
              :identifier="infiniteId"
              @infinite="infiniteHandler"
            >
              <div slot="spinner">Lade weitere Daten...</div>
              <div slot="no-more">Keine weiteren Daten</div>
              <div slot="no-results">Keine weiteren Daten gefunden</div>
            </infinite-loading>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import page from "@/mixins/Page";
import store from "@/store";
import Api from "@/Api";
import ContainerHeadline from "@/components/ContainerHeadline";
import InfiniteLoading from "vue-infinite-loading";
export default {
  name: "Dashboard",
  components: { InfiniteLoading, ContainerHeadline },
  mixins: [page],
  store,
  metaInfo() {
    return {
      titleTemplate: () => {
        return "Arvea Universe Dashboard";
      },
    };
  },
  data() {
    return {
      page: 0,
      anzahlProPage: 50,
      list: [],
      allOpenRows: [],
      ladeFehler: false,
      infiniteId: +new Date(),
      sortBy: "",
      sortDesc: false,
      isBusy: false,
      allOpenRowsFields: [
        { key: "selected", label: "" },
        {
          key: "date",
          sortable: true,
          label: "Date",
          variant: "success",
        },
        {
          key: "totalVolumeCalls",
          sortable: true,
          label: "Total Volume Calls",
          class: "text-right",
          variant: "success",
        },
        {
          key: "totalVolumePuts",
          sortable: true,
          label: "Total Volume Puts",
          class: "text-right",
          variant: "success",
        },
        {
          key: "deltaPut",
          sortable: true,
          label: "Δ Put",
          class: "text-center",
          variant: "success",
        },
        {
          key: "deltaCall",
          sortable: true,
          label: "Δ Call",
          class: "text-center",
          variant: "success",
          formatter: (value) => {
            if (value != null) {
              return value;
            } else {
              return "-";
            }
          },
        },
        {
          key: "callPercentage",
          sortable: true,
          label: "Call %",
          class: "text-center",
          variant: "success",
          formatter: (value) => {
            if (value != null) {
              return value;
            } else {
              return "-";
            }
          },
        },
        {
          key: "putPercentage",
          sortable: true,
          label: "Put %",
          class: "text-center",
          variant: "success",
          formatter: (value) => {
            if (value != null) {
              return value;
            } else {
              return "-";
            }
          },
        },
        {
          key: "avg",
          sortable: true,
          label: "Ø",
          class: "text-center",
          variant: "success",
          formatter: (value) => {
            if (value != null) {
              return value;
            } else {
              return "-";
            }
          },
        },
        {
          key: "scale",
          sortable: true,
          label: "Letter",
          class: "text-center",
          variant: "success",
          formatter: (value) => {
            if (value != null) {
              return value;
            } else {
              return "-";
            }
          },
        },
        {
          key: "ie",
          sortable: true,
          label: "IE",
          class: "text-center",
          variant: "success",
          formatter: (value) => {
            if (value != null) {
              return value;
            } else {
              return "-";
            }
          },
        },
      ],
      listFields: [
        { key: "selected", label: "" },
        {
          key: "symbol",
          sortable: true,
          label: "Symbol",
          /*
          formatter: (value) => {
            if (value) {
              return new Date(value * 1000).toLocaleDateString();
            } else {
              return "-";
            }
          },
          */
        },
        {
          key: "dates[0].ie",
          sortable: true,
          label: "IE",
          class: "text-center",
          formatter: (value) => {
            if (value != null) {
              return value;
            } else {
              return "-";
            }
          },
        },
        {
          key: "totalVolumeCalls",
          sortable: true,
          label: "Total Volume Calls",
          class: "text-right",
        },
        {
          key: "totalVolumePuts",
          sortable: true,
          label: "Total Volume Puts",
          class: "text-right",
        },
      ],
    };
  },
  watch: {},
  computed: {
    permissions() {
      return this.$store.state.permissions;
    },
  },
  created() {},
  mounted() {},
  methods: {
    infiniteHandler($state) {
      Api.get("data/", {}).then((response) => {
        if (response.data.symbols.length === this.anzahlProPage) {
          this.page += 1;
          this.list.push(...response.data.symbols);
          $state.loaded();
        } else {
          this.list.push(...response.data.symbols);
          $state.complete();
        }
      });
    },
    details(item, index) {
      console.log(index);
      this.allOpenRows.map((ele) => {
        if (ele.id !== item.id && ele._showDetails) {
          this.$set(ele, "_showDetails", !ele._showDetails);
        }
      });
      this.allOpenRows = [];
      this.$set(item, "_showDetails", !item._showDetails);
      item.dates.forEach((element) => {
        this.allOpenRows.push(element);
      });
    },
  },
};
</script>
<style>
</style>